const getUrlParameter = (parameter) => {
  const urlStr = window.location.href;
  const url = new URL(urlStr);
  const urlParams = url.searchParams;

  return urlParams.get(parameter);
};

export default getUrlParameter;
